import { ChartDatasetModel } from '@abb-procure/data';
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Injector,
  input,
  runInInjectionContext,
  signal,
} from '@angular/core';
import { Options } from 'highcharts';
import { HighchartsChartComponent } from 'highcharts-angular';

@Component({
  selector: 'procure-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrl: './doughnut-chart.component.scss',
  imports: [HighchartsChartComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoughnutChart {
  readonly dataset = input<ChartDatasetModel | null | undefined>();
  readonly height = input<number>(250);

  protected readonly chartOptions = signal<Options>({
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    chart: {
      type: 'pie',
      styledMode: true,
      height: 250,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        size: '100%',
      },
    },
    legend: {
      alignColumns: false,
      verticalAlign: 'middle',
      align: 'right',
      layout: 'vertical',
      squareSymbol: true,
      symbolRadius: 0,
      width: 150,
    },
    series: [
      {
        type: 'pie',
        data: [],
        innerSize: '50%',
      },
    ],
  });

  private readonly injector = inject(Injector);

  constructor() {
    afterNextRender(() => {
      runInInjectionContext(this.injector, () => {
        effect(() => {
          this.update(this.dataset() ?? undefined);
        });
      });
    });
  }

  private update(chartDataset?: ChartDatasetModel): void {
    if (!chartDataset) {
      return;
    }

    this.chartOptions.update((opts) => ({
      ...opts,
      series: [
        {
          type: 'pie',
          name: chartDataset.label ?? '',
          data: chartDataset.data?.map((data) => ({
            name: data.name ?? '',
            y: data.value || 0,
          })),
          innerSize: '50%',
        },
      ],
    }));
  }
}
